module.exports = __webpack_public_path__ + "img/fixture_color.c89cc811.svg";